<template>
  <router-link
    :to="link"
    class="main-item-wrapper d-flex flex-column cursor-pointer"
  >
    <div class="item_img">
      <img :src="image" @error="imageLoadError($event)" />
      <!-- add balik v-if="!locked" klu nk lock balik -->
      <div class="fav-icon-div titleHideOnHover" v-if="!locked">
        <img src="../../../assets/rtmklik/icon_play.svg" alt="play icon" />
      </div>
      <!-- uncomment klu nk lock balik -->
      <!-- <div class="fav-icon-div titleHideOnHover" v-else>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="24" height="24" rx="12" fill="#D9E021" />
          <path
            d="M7.42857 20C7.00953 20 6.65067 19.8507 6.352 19.552C6.05333 19.2533 5.90426 18.8947 5.90476 18.4762V10.8571C5.90476 10.4381 6.0541 10.0792 6.35276 9.78057C6.65143 9.4819 7.01003 9.33283 7.42857 9.33333H8.19048V7.80952C8.19048 6.75556 8.56203 5.85702 9.30514 5.11391C10.0483 4.37079 10.9465 3.99949 12 4C13.054 4 13.9525 4.37156 14.6956 5.11467C15.4387 5.85778 15.81 6.75606 15.8095 7.80952V9.33333H16.5714C16.9905 9.33333 17.3493 9.48267 17.648 9.78133C17.9467 10.08 18.0957 10.4386 18.0952 10.8571V18.4762C18.0952 18.8952 17.9459 19.2541 17.6472 19.5528C17.3486 19.8514 16.99 20.0005 16.5714 20H7.42857ZM7.42857 18.4762H16.5714V10.8571H7.42857V18.4762ZM12 16.1905C12.419 16.1905 12.7779 16.0411 13.0766 15.7425C13.3752 15.4438 13.5243 15.0852 13.5238 14.6667C13.5238 14.2476 13.3745 13.8888 13.0758 13.5901C12.7771 13.2914 12.4185 13.1423 12 13.1429C11.581 13.1429 11.2221 13.2922 10.9234 13.5909C10.6248 13.8895 10.4757 14.2481 10.4762 14.6667C10.4762 15.0857 10.6255 15.4446 10.9242 15.7432C11.2229 16.0419 11.5815 16.191 12 16.1905ZM9.71429 9.33333H14.2857V7.80952C14.2857 7.1746 14.0635 6.63492 13.619 6.19048C13.1746 5.74603 12.6349 5.52381 12 5.52381C11.3651 5.52381 10.8254 5.74603 10.381 6.19048C9.93651 6.63492 9.71429 7.1746 9.71429 7.80952V9.33333Z"
            fill="black"
          />
        </svg>
      </div> -->
    </div>
    <div class="titleHideOnHover" v-if="title">
      <p class="mb-0 title_text text-left mt-2">{{ title }}</p>
    </div>

    <div class="overlay">
      <div class="w-100 d-flex justify-content-between align-items-center mb-2">
        <div v-if="title">
          <p class="mb-0 title_text text-left mt-2">{{ title }}</p>
        </div>
        <!-- add balik v-if="!locked" klu nk lock balik -->
        <div class="fav-icon-div-onhover">
          <img src="../../../assets/rtmklik/icon_play.svg" alt="play icon" />
        </div>
        <!-- uncomment klu nk lock balik -->
        <!-- <div class="fav-icon-div-onhover" v-else>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="24" height="24" rx="12" fill="#D9E021" />
            <path
              d="M7.42857 20C7.00953 20 6.65067 19.8507 6.352 19.552C6.05333 19.2533 5.90426 18.8947 5.90476 18.4762V10.8571C5.90476 10.4381 6.0541 10.0792 6.35276 9.78057C6.65143 9.4819 7.01003 9.33283 7.42857 9.33333H8.19048V7.80952C8.19048 6.75556 8.56203 5.85702 9.30514 5.11391C10.0483 4.37079 10.9465 3.99949 12 4C13.054 4 13.9525 4.37156 14.6956 5.11467C15.4387 5.85778 15.81 6.75606 15.8095 7.80952V9.33333H16.5714C16.9905 9.33333 17.3493 9.48267 17.648 9.78133C17.9467 10.08 18.0957 10.4386 18.0952 10.8571V18.4762C18.0952 18.8952 17.9459 19.2541 17.6472 19.5528C17.3486 19.8514 16.99 20.0005 16.5714 20H7.42857ZM7.42857 18.4762H16.5714V10.8571H7.42857V18.4762ZM12 16.1905C12.419 16.1905 12.7779 16.0411 13.0766 15.7425C13.3752 15.4438 13.5243 15.0852 13.5238 14.6667C13.5238 14.2476 13.3745 13.8888 13.0758 13.5901C12.7771 13.2914 12.4185 13.1423 12 13.1429C11.581 13.1429 11.2221 13.2922 10.9234 13.5909C10.6248 13.8895 10.4757 14.2481 10.4762 14.6667C10.4762 15.0857 10.6255 15.4446 10.9242 15.7432C11.2229 16.0419 11.5815 16.191 12 16.1905ZM9.71429 9.33333H14.2857V7.80952C14.2857 7.1746 14.0635 6.63492 13.619 6.19048C13.1746 5.74603 12.6349 5.52381 12 5.52381C11.3651 5.52381 10.8254 5.74603 10.381 6.19048C9.93651 6.63492 9.71429 7.1746 9.71429 7.80952V9.33333Z"
              fill="black"
            />
          </svg>
        </div> -->
      </div>

      <p class="long-title text-left" v-if="description">
        {{ truncateString(description, 120) }}
      </p>
      <div class="w-100 d-flex justify-content-between flex-row"></div>
    </div>
  </router-link>
</template>

<script>
/* eslint-disable */
import noimage from "../../../assets/noimage.png";
export default {
  name: "episode-card-comp",
  props: [
    "image",
    "latestTag",
    "title",
    "description",
    "link",
    "category",
    "data",
    "locked",
  ],
  data: function() {
    return {
      mobile: false,
      window: {
        width: 0,
      },
      overlayData: this.data,
      classificationLabel: "",
      categoriesLabel: "",
      firstEpisodeLabel: "",
    };
  },
  methods: {
    imageLoadError(event) {
      event.target.src = noimage;
    },
    goTo(link) {
      this.$router.push(link);
    },

    truncateString(str, num) {
      if (str.length > num) {
        return str.slice(0, num) + "...";
      } else {
        return str;
      }
    },
    handleResizeforCard() {
      this.window.width = window.innerWidth;

      if (this.window.width >= 992) {
        this.mobile = false;
      } else {
        this.mobile = true;
      }
    },
    initData() {
      // const classificationFirst =
      //   this.overlayData.classification &&
      //   this.overlayData.classification.title &&
      //   this.overlayData.classification.title.en_US;
      // this.classificationLabel = classificationFirst ? classificationFirst : "";
      // getCategories
      // const categoriesFirst =
      //   this.overlayData.categories[0] &&
      //   this.overlayData.categories[0].title &&
      //   this.overlayData.categories[0].title.en_US;
      // this.categoriesLabel = categoriesFirst ? categoriesFirst : "";
    },
  },
  created() {
    window.addEventListener("resize", this.handleResizeforCard);
    this.handleResizeforCard();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResizeforCard);
  },
  mounted() {
    this.initData();
  },
};
</script>

<style scoped>
.main-item-wrapper {
  z-index: 1;
  text-decoration: none;
}
.main-item-wrapper:hover .title {
  display: none;
}
.item_img {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  padding-top: calc(145 / 220 * 100%);
  z-index: 1;
}
.item_img img {
  background: 100%;
  width: 100%;
  height: 100%;
  overflow: hidden;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  position: absolute;
  z-index: 2;
}
.main-item-wrapper .overlay {
  display: none;
}
.overlay {
  background: #171f26;
  padding: 8px;
  border-radius: 0 0 8px 8px;
  min-height: 120px;
}
.long-title {
  overflow: hidden;
  color: #fff;
  text-overflow: ellipsis;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
@media only screen and (min-width: 992px) {
  .main-item-wrapper:hover .titleDiv {
    display: none;
  }
  .main-item-wrapper:hover .titleHideOnHover {
    display: none;
  }
  .main-item-wrapper:hover .item_img {
    padding-top: calc(180 / 270 * 100%);
    border-radius: 8px 8px 0 0;
  }
  .main-item-wrapper:hover .overlay {
    display: block;
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 14;
    width: 100%;
  }
  .main-item-wrapper:hover .overlay {
    display: block;
    position: absolute;
    top: 99%;
    left: 0;
    z-index: 14;
    width: 100%;
  }
}

.tags-wrapper {
  width: 45px;
  padding: 2px 4px;
  height: 20px;
  position: absolute;
  right: 0;
  top: 8px;
  background-color: #f00;
  z-index: 4;
}
.tags-text {
  font-size: 12px;
  font-family: "HelveticaNeue-Bold";
  font-weight: bold;
  line-height: 1.25;
  text-align: left;
  color: #fff;
  z-index: 4;
}
.fav-icon-div {
  position: absolute;
  right: 8px;
  bottom: 8px;
  width: 24px;
  height: 24px;
  z-index: 4;
}
.fav-icon-div-onhover {
  width: 22px;
  height: 22px;
  z-index: 4;
}
.title_text {
  color: #fff;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media only screen and (max-width: 992px) {
  .item_img {
    filter: saturate(100%);
  }
}
@media only screen and (max-width: 480px) {
  .fav-icon-div {
    width: 24px;
    height: 24px;
    z-index: 4;
  }
}
</style>
<style>
@media only screen and (max-width: 480px) {
}
</style>
